__webpack_require__.p = "/personal-crypto-tracker/";